import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import "./TauriSidebarFilter.css";
import { Button, Dropdown } from "react-bootstrap";
import TauriImage from "../../../TauriImage/TauriImage";
import OpalSearchSuggestion from "./OpalSearchSuggestion/OpalSearchSuggestion";
import { createPortal } from "react-dom";
import { Form } from "react-bootstrap";
import MissedCallRequestModal from "../MissedCallRequestModal/MissedCallRequestModal";
import appURL from '../../../../appURL.json';
import { transformMissedCallRequests } from "../../CoverageFactoryData/CoverageFactoryData";
import OpalAlertModal from "../../../OpalAlertModal/OpalAlertModal";


const groupByOptions = [
    { key: false, label: "No Grouping" },
    { key: "InstitutionName", label: "Institutions" },
    { key: "Area", label: "Area/Territory" },
    { key: "Specialty", label: "Classifications" }
];

const orderByOptionss = [
    { key: "Time_Start", label: "Best Time to Visit" },
    { key: "Area", label: "Area/Territory" }
];

const sessionByOptions = [
    { key: true, label: "Show" },
    { key: false, label: "Hide" }
];

const TauriSidebarFilter = ({ searchTerm, setSearchTerm, selectedDate, setSelectedDate, setSelectedFilter, setIsSidebarCollapsed, showApplyMissedCall }) => {
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [inputRect, setInputRect] = useState(null);

    const [selectedGroupBy, setSelectedGroupBy] = useState(groupByOptions[0]);
    const [showFinishedSession, setShowFinishedSession] = useState(sessionByOptions[0]);
    const [selectedOrderBy, setSelectedOrderBy] = useState(orderByOptionss[0]);

    const [showMissedCallRequest, setShowMissedCallRequest] = useState(false);
    const [missedCallRequest, setMissedCallRequest] = useState(null);
    const [loading, setLoading] = useState(false);
    const [processingMissedCallRequest, setProcessingMissedCallRequest] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertModalProps, setAlertModalProps] = useState(null);

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));

    const inputRef = useRef();

    const menuRef = useRef();

    const fetchMissedCallRequest = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const devId = localStorage.getItem('devId');
            const c_id = localStorage.getItem('c_id');

            const selectedDateValue = new Date(selectedDate);
            const date = selectedDateValue.toLocaleDateString("en-CA");

            const response = await fetch(`${appURL.API_MissedCallRequest}/detail/${c_id}?d=${date}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                },
            });

            if (!response.ok) {
                return;
            }

            const result = await response.json();
            const mc = result?.missedCallRequest;

            const request = mc ? {
                ID: mc.id,
                Employee: {
                    ID: mc.employee?.id,
                    Code: mc.employee?.code,
                    Name: mc.employee?.name
                },
                RequestDate: mc.requestDate,
                ReasonID: mc.reasonID,
                Status: mc.status,
            } : null;

            setMissedCallRequest(request);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useLayoutEffect(() => {
        if (showSuggestion && inputRef.current) {
            const rect = inputRef.current.getBoundingClientRect();
            setInputRect({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width
            });
        }
    }, [showSuggestion]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelectedFilter(
            {
                orderby: selectedOrderBy?.key,
                groupby: selectedGroupBy?.key,
                show: showFinishedSession?.key
            })
        setShowMenu(false);
    }, [selectedGroupBy, showFinishedSession, selectedOrderBy]);


    useEffect(() => {
        fetchMissedCallRequest();
    }, [selectedDate]);

    const handleMissedCallRequest = async (payload) => {
        try {
            setProcessingMissedCallRequest(true);

            const employee_id = Number(permission?.coverage?.employee_id);
            const token = localStorage.getItem('token');
            const devId = localStorage.getItem('devId');
            const cycle_id = localStorage.getItem('c_id');

            const isUpdate = !!missedCallRequest?.ID;

            const url = isUpdate
                ? `${appURL.API_MissedCallRequest}/update/${missedCallRequest.ID}`
                : `${appURL.API_MissedCallRequest}/add/${employee_id}/${cycle_id}`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const error = await response.json();
                if (!error) return;
                const message = {
                    title: error?.category || "Error",
                    bodyText: error?.description || "An unexpected error occurred. Please try again later.",
                    modalType: "message"
                };

                setAlertModalProps(message);
                setShowAlertModal(true);
                return;
            };

            await fetchMissedCallRequest();
            setShowMissedCallRequest(false);
        } catch (err) {
            console.log(err);
        } finally {
            setProcessingMissedCallRequest(false);
        }
    }

    return (
        <>
            <div className="tauri-sidebar-filter">
                {/* Search Input */}
                <div className="tauri-sidebar-search d-flex align-items-center justify-content-center w-100 pt-2 px-1">
                    <div className="input-group">
                        <input
                            type="text"
                            ref={inputRef}
                            className="form-control"
                            placeholder="Search"
                            autoComplete="new-password"
                            value={searchTerm}
                            onMouseDown={() => setShowSuggestion(true)}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSearchTerm(value);
                                setShowSuggestion(value.length >= 3);
                            }}
                        />
                    </div>
                    <div ref={menuRef} style={{ position: "relative" }}>
                        <TauriImage
                            localImage={"/Images/akar-icons--settings-horizontal.svg"}
                            onClick={() => setShowMenu((prev) => !prev)}
                            alt="icon"
                            style={{ cursor: "pointer" }}
                        />
                        {showMenu && (
                            <div
                                className="opal-settings-menu"
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    right: 0,
                                    width: "17rem",
                                    backgroundColor: "#fff",
                                    border: "1px solid #B8CCE2",
                                    borderRadius: "0.25rem",
                                    zIndex: 10,
                                    marginTop: "0.25rem",
                                    padding: "0.5rem",
                                    fontSize: "0.8rem"
                                }}
                            >
                                <div className="row align-items-center mb-2">
                                    <div className="col-5 text-nowrap">Group By :</div>
                                    <div className="col-7">
                                        <Dropdown>
                                            <Dropdown.Toggle className="form-control text-start">
                                                {selectedGroupBy?.label}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {groupByOptions.map((item) => (
                                                    <Dropdown.Item key={item.key} onClick={() => setSelectedGroupBy(item)}>
                                                        {item.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {/* Finished Sessions */}
                                <div className="row align-items-center mb-2">
                                    <div className="col-5 text-nowrap">Finished Sessions :</div>
                                    <div className="col-7">
                                        <Dropdown>
                                            <Dropdown.Toggle className="form-control text-start">
                                                {showFinishedSession?.label}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {sessionByOptions.map((item) => (
                                                    <Dropdown.Item key={item.key} onClick={() => setShowFinishedSession(item)}>
                                                        {item.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {/* Order By */}
                                <div className="row align-items-center">
                                    <div className="col-5 text-nowrap">Order By :</div>
                                    <div className="col-7">
                                        <Dropdown>
                                            <Dropdown.Toggle className="form-control text-start">
                                                {selectedOrderBy?.label}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {orderByOptionss.map((item) => (
                                                    <Dropdown.Item key={item.key} onClick={() => setSelectedOrderBy(item)}>
                                                        {item.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {(showApplyMissedCall && !loading) && (
                                    <div className="row align-items-center mt-2">
                                        {!missedCallRequest ?
                                            <div className="col-12 text-nowrap">
                                                <Button onClick={() => setShowMissedCallRequest(true)}>Apply Missed Call</Button>
                                            </div> :
                                            <>
                                                <div className="col-5 text-nowrap">Request Status :</div>
                                                <div className="col-7 d-flex align-items-center">
                                                    <span className={`tauri-flex-text d-flex align-items-center status-${missedCallRequest?.Status?.toLowerCase()}`}>
                                                        {missedCallRequest?.Status}
                                                        <TauriImage
                                                            localImage={"/Images/mdi--eye.svg"}
                                                            onClick={() => setShowMissedCallRequest(true)}
                                                            alt="icon"
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </span>
                                                </div>
                                            </>
                                        }
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Suggestion rendered via portal */}
            {showSuggestion && inputRect &&
                createPortal(
                    <div
                        style={{
                            position: "absolute",
                            top: inputRect.top + 3,
                            left: inputRect.left,
                            width: inputRect.width,
                            zIndex: 5
                        }}
                    >
                        <OpalSearchSuggestion
                            show={showSuggestion}
                            setShowSuggestion={setShowSuggestion}
                            setSelectedDate={setSelectedDate}
                            search={searchTerm}
                            setSearch={setSearchTerm}
                        />
                    </div>,
                    document.body
                )
            }

            <MissedCallRequestModal
                show={showMissedCallRequest}
                onHide={() => setShowMissedCallRequest(false)}
                selectedDate={selectedDate}
                request={missedCallRequest}
                isCreating={processingMissedCallRequest}
                onProceed={handleMissedCallRequest}
            />

            <OpalAlertModal
                show={showAlertModal}
                onHide={() => setShowAlertModal(false)}
                title={alertModalProps?.title}
                bodyText={alertModalProps?.bodyText}
                confirmButtonText={alertModalProps?.confirmButtonText}
                cancelButtonText={alertModalProps?.cancelButtonText}
                onConfirm={alertModalProps?.onConfirm}
                modalType={alertModalProps?.modalType}
                Icon={alertModalProps?.Icon}
            />
        </>
    );
};

export default TauriSidebarFilter;
